<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">{{ $t("loadingTxt") }}...</div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="container-fluid">
                    <div class="row d-flex justify-content-between">
                      <div class="col-md-3">
                        <h4 class="float-start">
                          {{ $t("cml_billing_detail") }}
                        </h4>
                      </div>
                      <div class="col-md-7 collapse" id="collapseExample">
                        <div class="row d-flex">
                          <div class="col-md-3">
                            <label class="tx-11 fw-bolder mb-0">Created By :</label>
                            <p class="text-muted">{{ this.forms.addwho }}</p>
                          </div>
                          <div class="col-md-3">
                            <label class="tx-11 fw-bolder mb-0">Created At :</label>
                            <p class="text-muted">{{ this.forms.adddate }}</p>
                          </div>
                          <div class="col-md-3">
                            <label class="tx-11 fw-bolder mb-0">Updated By :</label>
                            <p class="text-muted">{{ this.forms.editwho }}</p>
                          </div>
                          <div class="col-md-3">
                            <label class="tx-11 fw-bolder mb-0">Updated At :</label>
                            <p class="text-muted">{{ this.forms.editdate }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="d-flex justify-content-end">
                          <div class="col-md">
                            <button
                              class="btn btn-light float-end"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseExample"
                              aria-expanded="false"
                              aria-controls="collapseExample"
                            >
                              <i class="link-icon" data-feather="info"></i>
                              Audit Info
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body mt-0">
                  <div class="container-fluid">
                    <div class="row mb-3">
                      <div class="col-md">
                        <label class="form-label">{{ $t("idBillingHeader") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="idBillingHeader"
                          :placeholder="$t('idBillingHeader')"
                          v-model="forms.idBillingHeader"
                          disabled
                        />
                      </div>
                      <div class="col-md">
                        <label class="form-label">{{ $t("customerId") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="customerId"
                          :placeholder="$t('customerId')"
                          v-model="forms.customerId"
                          disabled
                        />
                      </div>
                      <div class="col-md">
                        <label class="form-label">
                          {{ $t("warehouseId_txt") }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="warehouseId"
                          :placeholder="$t('warehouseId_txt')"
                          v-model="forms.warehouseId"
                          disabled
                        />
                      </div>
                      <div
                        class="col-md"
                        v-show="this.bm_tarif_master_header.beginningBalanceFlag == 'Y'"
                      >
                        <label class="form-label">
                          {{ $t("qtyBeginningBalance") }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="qtyBeginningBalance"
                          :placeholder="$t('qtyBeginningBalance')"
                          v-model="forms.qtyBeginningBalance"
                          disabled
                        />
                      </div>
                      <div
                        class="col-md"
                        v-show="this.bm_tarif_master_header.begBalRentPallFlag == 'Y'"
                      >
                        <label class="form-label">
                          {{ $t("qtyBegBalRentPall") }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="qtyBegBalRentPall"
                          :placeholder="$t('qtyBegBalRentPall')"
                          v-model="forms.qtyBegBalRentPall"
                          disabled
                        />
                      </div>
                      <div class="col-md">
                        <label class="form-label">{{ $t("multi_warehouse_flag") }}</label>

                        <span
                          data-bs-toggle="tooltip"
                          data-bs-placement="right"
                          title="customer menggunakan warehouse lebih dari satu ~ Y = Ya , N = Tidak"
                          class="mdi mdi mdi-help-circle-outline m-1 h5"
                        ></span>

                        <input
                          type="text"
                          class="form-control"
                          id="multiWhFlag"
                          :placeholder="$t('multi_warehouse_flag')"
                          v-model="forms.multiWhFlag"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("total_amount") }}</label>
                        <span
                          data-bs-toggle="tooltip"
                          data-bs-placement="right"
                          title="total amount didapat dari penjumlahan amount yang ada di DETAIL BILLING SUMMARY CATEGORY yang memiliki tanda icon CHECKLIST HIJAU"
                          class="mdi mdi mdi-help-circle-outline m-1 h5"
                        ></span>
                        <input
                          type="text"
                          class="form-control"
                          id="amount"
                          :placeholder="$t('amount_txt')"
                          v-model="forms.amount"
                          disabled
                        />
                      </div>
                      <div class="col-md-2">
                        <label class="form-label">
                          {{ $t("idRateHeader") }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="amount"
                          :placeholder="$t('idRateHeader')"
                          v-model="forms.idRateHeader"
                          disabled
                        />
                      </div>
                      <div class="col-md-2">
                        <label class="form-label">
                          {{ $t("tarifMasterId") }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="amount"
                          :placeholder="$t('tarifMasterId')"
                          v-model="forms.tarifMasterId"
                          disabled
                        />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">
                          {{ $t("transactionDate_txt") }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="transactionDate"
                          :placeholder="$t('transactionDate_txt')"
                          v-model="forms.transactionDate"
                          disabled
                        />
                      </div>
                      <div class="col-md-2">
                        <label class="form-label">
                          {{ $t("totalRowInterfaces") }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="warehouseId"
                          :placeholder="$t('totalRowInterfaces')"
                          v-model="forms.totalRowInterfaces"
                          disabled
                        />
                      </div>
                    </div>

                    <!-- row billing status -->
                    <div class="row mb-3">
                      <div class="col-md-4">
                        <label class="form-label">{{ $t("statusTxt") }}</label>
                        <h3 style="pointer-events: none">
                          <span :class="getBadgeClass(forms.status)">
                            <h5>{{ forms.status }}</h5>
                          </span>
                        </h3>
                      </div>
                      <div class="col-md-3 row">
                        <label class="form-label"><br /></label>
                        <button
                          v-show="
                            !excludedRoles.includes(this.roleName) &&
                            forms.weeklyTransmitFlag !== 'Y'
                          "
                          type="button"
                          class="btn btn-light"
                          @click="getDataLogsSyncTrx()"
                        >
                          <span class="mdi mdi-open-in-new"></span>
                          Logs Sync Trx
                          <span
                            v-show="formsLogsSyncTrxCount.LogsSyncTrxQueuedCount !== 0"
                            class="badge bg-secondary text-light"
                            style="margin-right: 5px"
                            >{{ formsLogsSyncTrxCount.LogsSyncTrxQueuedCount }}</span
                          >
                          <span
                            v-show="
                              formsLogsSyncTrxCount.LogsSyncTrxProcessingCount !== 0
                            "
                            class="badge bg-warning text-light"
                            style="margin-right: 5px"
                            >{{ formsLogsSyncTrxCount.LogsSyncTrxProcessingCount }}</span
                          >
                          <span
                            v-show="formsLogsSyncTrxCount.LogsSyncTrxFailedCount !== 0"
                            class="badge bg-danger text-light"
                            >{{ formsLogsSyncTrxCount.LogsSyncTrxFailedCount }}</span
                          >
                        </button>
                      </div>
                      <div class="col-md-5 row">
                        <div
                          class="btn-group"
                          v-show="
                            !excludedRoles.includes(this.roleName) &&
                            forms.weeklyTransmitFlag !== 'Y'
                          "
                        >
                          <div
                            class="d-flex justify-content-start"
                            v-if="
                              (this.roleName === 'superadmin' &&
                                forms.status === 'PROCESSING') ||
                              forms.status === 'COMPLETED'
                            "
                          >
                            <div class="input-group btn-group">
                              <label class="form-label w-100"
                                >{{ $t("recalculateByDate") }}
                                <span
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="right"
                                  title="data sebelumnya akan dihapus, kemudian data akan diambil ulang dan dihitung kembali"
                                  class="mdi mdi mdi-help-circle-outline m-1 h5"
                                ></span>
                              </label>
                              <date-range-picker
                                type="input"
                                class="col-md-6"
                                @update="recalculateDates()"
                                control-container-class="form-control"
                                :locale-data="{ format: 'yyyy-mm-dd' }"
                                v-model="recalculateDataDates"
                                :opens="opens"
                                :singleDatePicker="false"
                                :timePicker24Hour="false"
                                :timePicker="false"
                                :showWeekNumbers="false"
                              >
                                <div slot="header" slot-scope="header" class="slot">
                                  <a @click="clearrecalculateDates()"></a>
                                  <span v-if="header.in_selection">
                                    - {{ $t("inSelection") }}</span
                                  >
                                  <span v-if="header.in_selection">
                                    - {{ $t("inSelection") }}</span
                                  >
                                </div>
                              </date-range-picker>
                              <div class="input-group-append btn-group">
                                <button
                                  @click="destroyMassSubDetailOnlyByDate"
                                  class="btn btn-light"
                                  type="button"
                                >
                                  <span class="mdi mdi-cloud-sync-outline"></span>
                                  {{ $t("recalculateByDate") }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- row template upload -->
                    <div
                      class="row mb-3"
                      v-if="['PROCESSING', 'COMPLETED'].includes(forms.status)"
                    >
                      <label
                        v-if="
                          (permision_role.method_upload && forms.overtimeFlag == 'Y') ||
                          forms.extraHandlingFlag == 'Y' ||
                          forms.sapDataFlag == 'Y' ||
                          forms.additionalDataWMSFlag == 'Y' ||
                          forms.dataAdditionalStorageWmsFlag == 'Y'
                        "
                        class="form-label"
                        >{{ $t("UploadTxt") }}</label
                      >
                      <div class="d-grid gap-2 d-md-flex justify-content-md-start">
                        <span
                          v-if="
                            permision_role.method_custom2 &&
                            permision_role.method_update &&
                            forms.overtimeFlag == 'Y'
                          "
                        >
                          <button
                            class="btn btn-dark text-light fw-bolder btn-icon-text"
                            @click="uploadOvertime()"
                            type="button"
                          >
                            <span class="mdi mdi-upload"></span>
                            {{ $t("overtime") }}
                          </button>
                        </span>
                        <span
                          v-if="
                            permision_role.method_custom3 &&
                            permision_role.method_update &&
                            forms.extraHandlingFlag == 'Y'
                          "
                        >
                          <button
                            class="btn btn-dark text-light fw-bolder btn-icon-text"
                            @click="uploadExtraHandling()"
                            type="button"
                          >
                            <span class="mdi mdi-upload"></span>
                            {{ $t("extraHandling") }}
                          </button>
                        </span>
                        <span
                          v-if="
                            permision_role.method_custom4 &&
                            permision_role.method_update &&
                            forms.sapDataFlag == 'Y'
                          "
                        >
                          <button
                            class="btn btn-dark text-light fw-bolder btn-icon-text"
                            @click="uploadDataSAP()"
                            type="button"
                          >
                            <span class="mdi mdi-upload"></span>
                            {{ $t("trxSap") }}
                          </button>
                        </span>
                        <span
                          v-if="
                            permision_role.method_custom5 &&
                            permision_role.method_update &&
                            forms.additionalDataWMSFlag == 'Y'
                          "
                        >
                          <button
                            class="btn btn-dark text-light fw-bolder btn-icon-text"
                            @click="uploadDataAdditionalWMS()"
                            type="button"
                          >
                            <span class="mdi mdi-upload"></span>
                            {{ $t("addHandlingWms") }}
                          </button>
                        </span>
                        <span
                          v-if="
                            permision_role.method_custom5 &&
                            permision_role.method_update &&
                            forms.dataAdditionalStorageWmsFlag == 'Y'
                          "
                        >
                          <button
                            class="btn btn-dark text-light fw-bolder btn-icon-text"
                            @click="uploadDataAdditionalStorageWms()"
                            type="button"
                          >
                            <span class="mdi mdi-upload"></span>
                            {{ $t("addStorageWms") }}
                          </button>
                        </span>
                      </div>
                    </div>

                    <!--DETAIL BILLING SUMMARY CATEGORY-->
                    <div class="row section-header mb-4 mt-5">
                      <div class="col-md-4">
                        <div class="card-header">
                          <h6 class="card-title mb-0 float-start">
                            {{ $t("billing_summary_detail_txt") }}
                          </h6>
                        </div>
                      </div>
                      <div class="col-md-5">
                        <div class="d-flex justify-content-start">
                          <div class="btn-group w-100" role="group">
                            <button
                              @click="getRateDetail()"
                              type="button"
                              class="btn btn-light"
                              v-show="!excludedRoles.includes(this.roleName)"
                            >
                              <span class="mdi mdi-open-in-new"></span>
                              {{ $t("dataRate") }}
                            </button>
                            <button
                              @click="getDataSAP()"
                              type="button"
                              class="btn btn-light"
                              v-if="forms.sapDataFlag == 'Y'"
                            >
                              <span class="mdi mdi-open-in-new"></span>
                              {{ $t("dataSAP") }}
                            </button>
                            <button
                              @click="getDataAkumActivity()"
                              type="button"
                              class="btn btn-light"
                              v-if="forms.akumFlag == 'Y'"
                            >
                              <span class="mdi mdi-open-in-new"></span>
                              {{ $t("dataAkumulasi") }}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <button
                          v-if="permision_role.method_read"
                          class="btn btn-success float-end"
                          @click.prevent="downloadDataBillingDetail()"
                        >
                          <span class="mdi mdi-download"></span>
                          {{ $t("downloadData") }} .xlsx
                        </button>
                      </div>
                    </div>

                    <!--table-->
                    <div class="row mb-3" v-if="excludedRoles.includes(roleName)">
                      <vue-good-table
                        title="list-billing-cli-billing-details"
                        :rows="rows"
                        :line-numbers="true"
                        styleClass="vgt-table striped"
                        :columns="columns"
                        :sort-options="{
                          enabled: true,
                        }"
                        :search-options="{
                          enabled: true,
                          trigger: 'enter',
                        }"
                      >
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'actions'">
                            <a
                              href="#"
                              v-if="
                                permision_role.method_read &&
                                ![
                                  'MINIMUM',
                                  'STORAGE MIXING',
                                  'STORAGE EXCESS',
                                  'RENTAL PALLET EXCESS',
                                ].includes(props.row.rateBaseDesc) &&
                                props.row.chargeCategory !== 'FIX CHARGE'
                              "
                              title="Sub Detail"
                              @click.prevent="detailDataDetail(props.index, props.row)"
                            >
                              <span
                                v-if="props.row.additionalFlag == 'Y'"
                                class="mdi mdi-eye-plus m-1 h4"
                              ></span>
                              <span v-else class="mdi mdi-eye m-1 h4"></span>
                            </a>

                            <a
                              href="#"
                              v-if="
                                (props.row.summaryFlag == 'Y' &&
                                  permision_role.method_read &&
                                  props.row.rateBaseCode == 'DO') ||
                                props.row.rateBaseCode == 'CTN'
                              "
                              title="Sub Summary"
                              @click.prevent="detailSumHandling(props.index, props.row)"
                            >
                              <span class="mdi mdi-chart-box-outline m-1 h3"></span>
                            </a>

                            <span
                              v-if="
                                (permision_role.method_read &&
                                  props.row.summaryFlag === 'Y' &&
                                  props.row.chargeCategory === 'STORAGE') ||
                                props.row.chargeCategory === 'RENTAL PALLET'
                              "
                            >
                              <span v-if="props.row.rateBaseDesc.includes('BY MUID')">
                                <a
                                  href="#"
                                  title="Sub Summary"
                                  @click.prevent="
                                    detailSumStrgMuid(props.index, props.row)
                                  "
                                >
                                  <span class="mdi mdi-chart-box-outline m-1 h3"></span>
                                </a>
                              </span>
                              <span v-if="props.row.rateBaseDesc.includes('BY QTY')">
                                <a
                                  href="#"
                                  title="Sub Summary"
                                  @click.prevent="
                                    detailSumStrgQty(props.index, props.row)
                                  "
                                >
                                  <span class="mdi mdi-chart-box-outline m-1 h3"></span>
                                </a>
                              </span>
                              <span
                                v-if="
                                  props.row.rateBaseDesc.includes('BY TRACE ID') ||
                                  props.row.rateBaseDesc.includes('BEGINNING BALANCE')
                                "
                              >
                                <a
                                  href="#"
                                  title="Sub Summary"
                                  @click.prevent="
                                    detailSumStrgPltUsed(props.index, props.row)
                                  "
                                >
                                  <span class="mdi mdi-chart-box-outline m-1 h3"></span>
                                </a>
                              </span>
                              <span
                                v-if="
                                  props.row.rateBaseDesc.includes('BY CBM')
                                "
                              >
                                <a
                                  href="#"
                                  title="Sub Summary"
                                  @click.prevent="
                                    detailSumStrgMultiWh(props.index, props.row)
                                  "
                                >
                                  <span class="mdi mdi-chart-box-outline m-1 h3"></span>
                                </a>
                              </span>
                            </span>

                            <span
                              title="Flag Total Amount"
                              class="mdi mdi-check-circle-outline m-1 h4 text-success"
                              v-if="props.row.logicTotalAmountFlag == '1'"
                            ></span>
                            <span
                              title="Flag Total Amount"
                              class="mdi mdi-close-circle-outline m-1 h4 text-danger"
                              v-if="props.row.logicTotalAmountFlag == '0'"
                            ></span>
                          </span>

                          <span v-if="props.column.field == 'amountCategory'"> - </span>
                          <span v-else-if="props.column.field == 'rate'"> - </span>
                          <span v-else-if="props.column.field == 'chargeType'">
                            <span class="row">
                              <span class="col"> Charge Type </span>
                              <span class="col-8"> : {{ props.row.chargeType }} </span>
                            </span>
                            <span class="row">
                              <span class="col"> SAP Material Code </span>
                              <span class="col-8">
                                : {{ props.row.SAPMaterialCode }}
                              </span>
                            </span>
                            <span class="row">
                              <span class="col"> SAP Division </span>
                              <span class="col-8"> : {{ props.row.SAPDivision }} </span>
                            </span>
                          </span>
                          <span v-else-if="props.column.field == 'chargeCategory'">
                            <span class="row">
                              <span class="col"> Id Billing Detail </span>
                              <span class="col-8">
                                : {{ props.row.idBillingDetail }}
                              </span>
                            </span>
                            <strong>
                              <span class="row">
                                <span class="col"> Category </span>
                                <span class="col-8">
                                  : {{ props.row.chargeCategory }}
                                </span>
                              </span>
                            </strong>
                            <span class="row">
                              <span class="col"> Rate Base </span>
                              <span class="col-8"> : {{ props.row.rateBaseDesc }} </span>
                            </span>
                          </span>

                          <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                          </span>
                        </template>
                      </vue-good-table>
                    </div>
                    <div class="row mb-3" v-else>
                      <vue-good-table
                        title="list-billing-cli-billing-details"
                        :rows="rows"
                        :line-numbers="true"
                        styleClass="vgt-table striped"
                        :columns="columns"
                        :sort-options="{
                          enabled: true,
                        }"
                        :search-options="{
                          enabled: true,
                          trigger: 'enter',
                        }"
                      >
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'actions'">
                            <a
                              href="#"
                              v-if="
                                permision_role.method_read &&
                                ![
                                  'MINIMUM',
                                  'STORAGE MIXING',
                                  'STORAGE EXCESS',
                                  'RENTAL PALLET EXCESS',
                                ].includes(props.row.rateBaseDesc) &&
                                props.row.chargeCategory !== 'FIX CHARGE'
                              "
                              title="Sub Detail"
                              @click.prevent="detailDataDetail(props.index, props.row)"
                            >
                              <span
                                v-if="props.row.additionalFlag == 'Y'"
                                class="mdi mdi-eye-plus m-1 h4"
                              ></span>
                              <span v-else class="mdi mdi-eye m-1 h4"></span>
                            </a>

                            <a
                              href="#"
                              v-if="
                                (props.row.summaryFlag == 'Y' &&
                                  permision_role.method_read &&
                                  props.row.rateBaseCode == 'DO') ||
                                props.row.rateBaseCode == 'CTN'
                              "
                              title="Sub Summary"
                              @click.prevent="detailSumHandling(props.index, props.row)"
                            >
                              <span class="mdi mdi-chart-box-outline m-1 h3"></span>
                            </a>

                            <span
                              v-if="
                                (permision_role.method_read &&
                                  props.row.summaryFlag === 'Y' &&
                                  props.row.chargeCategory === 'STORAGE') ||
                                props.row.chargeCategory === 'RENTAL PALLET'
                              "
                            >
                              <span v-if="props.row.rateBaseDesc.includes('BY MUID')">
                                <a
                                  href="#"
                                  title="Sub Summary"
                                  @click.prevent="
                                    detailSumStrgMuid(props.index, props.row)
                                  "
                                >
                                  <span class="mdi mdi-chart-box-outline m-1 h3"></span>
                                </a>
                              </span>
                              <span v-if="props.row.rateBaseDesc.includes('BY QTY')">
                                <a
                                  href="#"
                                  title="Sub Summary"
                                  @click.prevent="
                                    detailSumStrgQty(props.index, props.row)
                                  "
                                >
                                  <span class="mdi mdi-chart-box-outline m-1 h3"></span>
                                </a>
                              </span>
                              <span
                                v-if="
                                  props.row.rateBaseDesc.includes('BY TRACE ID') ||
                                  props.row.rateBaseDesc.includes('BEGINNING BALANCE')
                                "
                              >
                                <a
                                  href="#"
                                  title="Sub Summary"
                                  @click.prevent="
                                    detailSumStrgPltUsed(props.index, props.row)
                                  "
                                >
                                  <span class="mdi mdi-chart-box-outline m-1 h3"></span>
                                </a>
                              </span>
                              <span
                                v-if="
                                  props.row.rateBaseDesc.includes('BY CBM')
                                "
                              >
                                <a
                                  href="#"
                                  title="Sub Summary"
                                  @click.prevent="
                                    detailSumStrgMultiWh(props.index, props.row)
                                  "
                                >
                                  <span class="mdi mdi-chart-box-outline m-1 h3"></span>
                                </a>
                              </span>
                            </span>

                            <span
                              title="Flag Total Amount"
                              class="mdi mdi-check-circle-outline m-1 h4 text-success"
                              v-if="props.row.logicTotalAmountFlag == '1'"
                            ></span>
                            <span
                              title="Flag Total Amount"
                              class="mdi mdi-close-circle-outline m-1 h4 text-danger"
                              v-if="props.row.logicTotalAmountFlag == '0'"
                            ></span>
                          </span>

                          <span v-if="props.column.field == 'amountCategory'">
                            {{ toCurrency(props.row.amountCategory) }}
                          </span>
                          <span v-else-if="props.column.field == 'rate'">
                            {{ toCurrency(props.row.rate) }}
                          </span>
                          <span v-else-if="props.column.field == 'chargeType'">
                            <span class="row">
                              <span class="col"> Charge Type </span>
                              <span class="col-8"> : {{ props.row.chargeType }} </span>
                            </span>
                            <span class="row">
                              <span class="col"> SAP Material Code </span>
                              <span class="col-8">
                                : {{ props.row.SAPMaterialCode }}
                              </span>
                            </span>
                            <span class="row">
                              <span class="col"> SAP Division </span>
                              <span class="col-8"> : {{ props.row.SAPDivision }} </span>
                            </span>
                          </span>
                          <span v-else-if="props.column.field == 'chargeCategory'">
                            <span class="row">
                              <span class="col"> Id Billing Detail </span>
                              <span class="col-8">
                                : {{ props.row.idBillingDetail }}
                              </span>
                            </span>
                            <strong>
                              <span class="row">
                                <span class="col"> Category </span>
                                <span class="col-8">
                                  : {{ props.row.chargeCategory }}
                                </span>
                              </span>
                            </strong>
                            <span class="row">
                              <span class="col"> Rate Base </span>
                              <span class="col-8"> : {{ props.row.rateBaseDesc }} </span>
                            </span>
                          </span>

                          <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                          </span>
                        </template>
                      </vue-good-table>
                    </div>
                    <!--table-->

                    <div class="card-footer">
                      <button
                        class="btn btn-primary fw-bolder btn-icon-text m-1"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      <span v-show="!excludedRoles.includes(this.roleName)">
                        <button
                          v-if="
                            permision_role.method_update &&
                            [
                              'PROCESSING',
                              'COMPLETED',
                              'CONFIRMED',
                              'INTERFACE PROCESSING',
                              'INTERFACE FAILED',
                              'INTERFACE COMPLETED',
                            ].includes(forms.status)
                          "
                          class="btn btn-success fw-bolder btn-icon-text m-1"
                          @click="downloadForm()"
                          type="button"
                        >
                          <span class="mdi mdi-list-status h4"></span>
                          {{ $t("downloadDataList") }}
                        </button>
                      </span>
                      <button
                        v-if="
                          (permision_role.method_update && forms.status == 'DRAFT') ||
                          forms.status == 'COMPLETED'
                        "
                        class="btn btn-info fw-bolder btn-icon-text m-1"
                        @click="editForm()"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-pencil"></i>
                        {{ $t("editMess") }}
                      </button>
                      <button
                        v-if="permision_role.method_delete && forms.status == 'DRAFT'"
                        class="btn btn-info fw-bolder btn-icon-text m-1"
                        @click="deleteForm()"
                        type="button"
                      >
                        <i class="link-icon mdi mdi-trash-can-outline"></i>
                        {{ $t("deleteMess") }}
                      </button>
                      <span
                        v-show="
                          (permision_role.method_update && forms.status == 'COMPLETED') ||
                          forms.status == 'PROCESSING'
                        "
                      >
                        <button
                          class="btn btn-warning fw-bolder btn-icon-text m-1"
                          @click="recalculateData()"
                          type="button"
                        >
                          <span class="mdi mdi-calculator h4"></span>
                          {{ $t("recalculateAmount") }}
                        </button>
                      </span>
                      <button
                        v-show="
                          forms.sapDataFlag === 'Y' &&
                          permision_role.method_custom4 &&
                          permision_role.method_update &&
                          ![
                            'CONFIRMED',
                            'INTERFACE PROCESSING',
                            'INTERFACE FAILED',
                            'INTERFACE COMPLETED',
                            'MATCHING PROCESS',
                            'RECALCULATE',
                            'DRAFT',
                          ].includes(forms.status)
                        "
                        class="btn btn-warning fw-bolder btn-icon-text m-1"
                        @click="dataMatchingProcess()"
                        type="button"
                      >
                        <span class="mdi mdi-compare-remove h4"></span>
                        {{ $t("dataMatchingProcess") }}
                      </button>
                      <button
                        v-show="
                          forms.weeklyTransmitFlag === 'Y' &&
                          permision_role.method_update &&
                          forms.interfaceStatus === 0 &&
                          ['PROCESSING', 'COMPLETED', 'INTERFACE FAILED'].includes(
                            forms.status
                          )
                        "
                        class="btn btn-warning fw-bolder btn-icon-text m-1"
                        @click="weeklyTransmit()"
                        type="button"
                      >
                        <span class="mdi mdi-transfer h4"></span>
                        {{ $t("weeklyTransmitFlag") }}
                      </button>
                      <button
                        v-show="
                          (permision_role.method_custom1 &&
                            permision_role.method_update &&
                            forms.interfaceStatus == 0 &&
                            forms.status == 'COMPLETED') ||
                          ['INTERFACE NOT COMPLETED', 'INTERFACE FAILED'].includes(
                            forms.status
                          )
                        "
                        class="btn btn-danger fw-bolder btn-icon-text m-1"
                        @click="confirmedData()"
                        type="button"
                      >
                        <span class="mdi mdi-hand-okay h4"></span>
                        {{ $t("confirmed") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::modal-->
        <modal
          name="detailRateCmlbilling"
          :draggable="false"
          :scrollable="true"
          :height="'auto'"
        >
          <div
            class="modal fade show"
            tabindex="-1"
            style="display: block; margin-top: 2%"
            aria-modal="true"
            role="dialog"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    {{ this.$t("rate_detail_txt") }}
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    aria-label="btn-close"
                    @click.prevent="removeModals()"
                  ></button>
                </div>

                <div class="modal-body">
                  <div class="mb-3">
                    <label for="organizationId" class="form-label"
                      >{{ this.$t("organizationId") }}:</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="organizationId"
                      :placeholder="$t('organizationId')"
                      v-model="bm_rate_header.organizationId"
                      disabled
                    />
                  </div>

                  <div class="mb-3">
                    <label for="warehouseId" class="form-label"
                      >{{ this.$t("warehouseId_txt") }}:</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="warehouseId"
                      :placeholder="$t('warehouseId_txt')"
                      v-model="bm_rate_header.warehouseId"
                      disabled
                    />
                  </div>

                  <div class="mb-3">
                    <label for="customerId" class="form-label"
                      >{{ this.$t("customerId") }}:</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="customerId"
                      :placeholder="$t('customerId')"
                      v-model="bm_rate_header.customerId"
                      disabled
                    />
                  </div>

                  <div class="mb-3">
                    <label for="customerSAPCode" class="form-label"
                      >{{ this.$t("customerSAPCode") }}:</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="customerSAPCode"
                      :placeholder="$t('customerSAPCode')"
                      v-model="bm_rate_header.customerSAPCode"
                      disabled
                    />
                  </div>

                  <div class="mb-3">
                    <label for="firstBilingDate" class="form-label"
                      >{{ this.$t("firstBilingDate_txt") }}:</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="firstBilingDate"
                      :placeholder="$t('firstBilingDate_txt')"
                      v-model="bm_rate_header.firstBilingDate"
                      disabled
                    />
                  </div>

                  <div class="mb-3">
                    <div class="row">
                      <div class="col-sm-6">
                        <label for="effectiveFromDate" class="form-label"
                          >{{ this.$t("effectiveFromDate") }}:</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="effectiveFromDate"
                          :placeholder="$t('effectiveFromDate')"
                          v-model="bm_rate_header.effectiveFromDate"
                          disabled
                        />
                      </div>
                      <div class="col-sm-6">
                        <label for="effectiveToDate" class="form-label"
                          >{{ this.$t("effectiveToDate") }}:</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="effectiveToDate"
                          :placeholder="$t('effectiveToDate')"
                          v-model="bm_rate_header.effectiveToDate"
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="status" class="form-label"
                      >{{ this.$t("statusTxt") }}:</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="status"
                      :placeholder="$t('statusTxt')"
                      v-model="bm_rate_header.status"
                      disabled
                    />
                  </div>

                  <div class="mb-3">
                    <label for="addwho" class="form-label"
                      >{{ this.$t("addwho") }}:</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="addwho"
                      :placeholder="$t('addwho')"
                      v-model="bm_rate_header.addwho"
                      disabled
                    />
                  </div>

                  <div class="mb-3">
                    <label for="adddate" class="form-label"
                      >{{ this.$t("adddate") }}:</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="adddate"
                      :placeholder="$t('adddate')"
                      v-model="bm_rate_header.adddate"
                      disabled
                    />
                  </div>

                  <div class="mb-3">
                    <label for="editwho" class="form-label"
                      >{{ this.$t("editwho") }}:</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="editwho"
                      :placeholder="$t('editwho')"
                      v-model="bm_rate_header.editwho"
                      disabled
                    />
                  </div>

                  <div class="mb-3">
                    <label for="editdate" class="form-label"
                      >{{ this.$t("editdate") }}:</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="editdate"
                      :placeholder="$t('editdate')"
                      v-model="bm_rate_header.editdate"
                      disabled
                    />
                  </div>
                </div>

                <div class="modal-footer justify-content-between">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click.prevent="removeModals()"
                  >
                    {{ this.$t("close_txt") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </modal>

        <modal
          name="uploadOvertime"
          :draggable="false"
          :scrollable="true"
          :height="'auto'"
        >
          <div
            class="modal fade show"
            tabindex="-1"
            style="display: block; margin-top: 2%"
            aria-modal="true"
            role="dialog"
          >
            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content">
                <form class="forms-sample" @submit.prevent="submitOvertime" method="POST">
                  <div class="modal-header">
                    <h5 class="modal-title" id="uploadOvertime">
                      {{ this.$t("upload_overtime") }}
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      aria-label="btn-close"
                      @click.prevent="removeModals()"
                    ></button>
                  </div>

                  <div class="modal-body">
                    <div class="mb-3">
                      <label for="files" class="form-label">{{ this.$t("file") }}:</label>
                      <input
                        type="file"
                        class="form-control"
                        ref="fileOvertime"
                        @change="handleFileUploadOvertime($event)"
                        required
                      />

                      <div v-if="errors.file_overtime">
                        <div
                          v-for="error in errors.file_overtime"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <br />
                      <label for="download_template_vas" class="form-label"
                        ><a
                          @click="downloadOvertimeTemplate()"
                          style="color: #6571ff; text-decoration: none"
                          >{{ this.$t("download_template_overtime") }}</a
                        ></label
                      >
                    </div>

                    <div class="mb-3" v-if="errorsOvertimeUpload">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <th>{{ $t("lineNo") }}</th>
                            <th>{{ $t("statusTxt") }}</th>
                            <th>{{ $t("messageTxt") }}</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(errorOvertime, index) in errorsOvertimeUpload"
                              :key="index"
                            >
                              <th>{{ errorOvertime.No }}</th>
                              <th>{{ errorOvertime.status }}</th>
                              <th>{{ errorOvertime.message }}</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer justify-content-between">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click.prevent="removeModals()"
                    >
                      {{ this.$t("close_txt") }}
                    </button>
                    <button type="submit" class="btn btn-primary">
                      {{ this.$t("UploadTxt") }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </modal>

        <modal
          name="uploadExtraHandling"
          :draggable="false"
          :scrollable="true"
          :height="'auto'"
        >
          <div
            class="modal fade show"
            tabindex="-1"
            style="display: block; margin-top: 2%"
            aria-modal="true"
            role="dialog"
          >
            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content">
                <form
                  class="forms-sample"
                  @submit.prevent="submitExtraHandling"
                  method="POST"
                >
                  <div class="modal-header">
                    <h5 class="modal-title" id="uploadOExtraHandling">
                      {{ this.$t("upload_extra_handling") }}
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      aria-label="btn-close"
                      @click.prevent="removeModals()"
                    ></button>
                  </div>

                  <div class="modal-body">
                    <div class="mb-3">
                      <label for="files" class="form-label">{{ this.$t("file") }}:</label>
                      <input
                        type="file"
                        class="form-control"
                        ref="fileExtraHandling"
                        @change="handleFileUploadExtraHandling($event)"
                        required
                      />

                      <div v-if="errors.file_extra_handling">
                        <div
                          v-for="error in errors.file_extra_handling"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <br />
                      <label for="download_template_extra_handling" class="form-label"
                        ><a
                          @click="downloadExtraHandlingTemplate()"
                          style="color: #6571ff; text-decoration: none"
                          >{{ this.$t("download_template_extra_handling") }}</a
                        ></label
                      >
                    </div>

                    <div class="mb-3" v-if="errorsExtraHandlingUpload">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <th>{{ $t("lineNo") }}</th>
                            <th>{{ $t("statusTxt") }}</th>
                            <th>{{ $t("messageTxt") }}</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(
                                errorExtraHandling, index
                              ) in errorsExtraHandlingUpload"
                              :key="index"
                            >
                              <th>{{ errorExtraHandling.No }}</th>
                              <th>{{ errorExtraHandling.status }}</th>
                              <th>{{ errorExtraHandling.message }}</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer justify-content-between">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click.prevent="removeModals()"
                    >
                      {{ this.$t("close_txt") }}
                    </button>
                    <button type="submit" class="btn btn-primary">
                      {{ this.$t("UploadTxt") }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </modal>

        <modal
          name="uploadDataSAP"
          :draggable="false"
          :scrollable="true"
          :height="'auto'"
        >
          <div
            class="modal fade show"
            tabindex="-1"
            style="display: block; margin-top: 2%"
            aria-modal="true"
            role="dialog"
          >
            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content">
                <form class="forms-sample" @submit.prevent="submitDataSAP" method="POST">
                  <div class="modal-header">
                    <h5 class="modal-title" id="uploadDataSAP">
                      {{ this.$t("uploadDataSAP") }}
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      aria-label="btn-close"
                      @click.prevent="removeModals()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div class="mb-3">
                      <label for="files" class="form-label">{{ this.$t("file") }}:</label>
                      <input
                        type="file"
                        class="form-control"
                        ref="fileDataSAP"
                        @change="handleFileUploadDataSAP($event)"
                        required
                      />

                      <div v-if="errors.file_data_sap">
                        <div
                          v-for="error in errors.file_data_sap"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                    <div class="mb-3">
                      <br />
                      <label for="downloadTemplateDataSAP" class="form-label">
                        <a
                          @click="downloadDataSAPTemplate()"
                          style="color: #6571ff; text-decoration: none"
                        >
                          {{ this.$t("downloadTemplateDataSAP") }}
                        </a>
                      </label>
                    </div>
                    <div class="mb-3" v-if="errorsDataSAPUpload">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <th>{{ $t("lineNo") }}</th>
                            <th>{{ $t("statusTxt") }}</th>
                            <th>{{ $t("messageTxt") }}</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(errorDataSAP, index) in errorsDataSAPUpload"
                              :key="index"
                            >
                              <th>{{ errorDataSAP.No }}</th>
                              <th>{{ errorDataSAP.status }}</th>
                              <th>{{ errorDataSAP.message }}</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer justify-content-between">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click.prevent="removeModals()"
                    >
                      {{ this.$t("close_txt") }}
                    </button>
                    <button type="submit" class="btn btn-primary">
                      {{ this.$t("UploadTxt") }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </modal>

        <modal
          name="uploadDataAdditionalWMS"
          :draggable="false"
          :scrollable="true"
          :height="'auto'"
        >
          <div
            class="modal fade show"
            tabindex="-1"
            style="display: block; margin-top: 2%"
            aria-modal="true"
            role="dialog"
          >
            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content">
                <form
                  class="forms-sample"
                  @submit.prevent="submitDataAdditionalWMS"
                  method="POST"
                >
                  <div class="modal-header">
                    <h5 class="modal-title" id="uploadDataAdditionalWMS">
                      {{ this.$t("uploadDataAdditionalWMS") }}
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      aria-label="btn-close"
                      @click.prevent="removeModals()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div class="mb-3">
                      <label for="files" class="form-label">{{ this.$t("file") }}:</label>
                      <input
                        type="file"
                        class="form-control"
                        ref="fileDataSAP"
                        @change="handleFileUploadDataAdditionalWMS($event)"
                        required
                      />

                      <div v-if="errors.file_data_additional_wms">
                        <div
                          v-for="error in errors.file_data_additional_wms"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                    <div class="mb-3">
                      <br />
                      <label for="downloadTemplateDataAdditionalWMS" class="form-label">
                        <a
                          @click="downloadDataAdditionalWMSTemplate()"
                          style="color: #6571ff; text-decoration: none"
                        >
                          {{ this.$t("downloadTemplateDataAdditionalWMS") }}
                        </a>
                      </label>
                    </div>
                    <div class="mb-3" v-if="errorsDataAdditionalWMSUpload">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <th>{{ $t("lineNo") }}</th>
                            <th>{{ $t("statusTxt") }}</th>
                            <th>{{ $t("messageTxt") }}</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(
                                errorDataAdditionalWMS, index
                              ) in errorsDataAdditionalWMSUpload"
                              :key="index"
                            >
                              <th>{{ errorDataAdditionalWMS.No }}</th>
                              <th>{{ errorDataAdditionalWMS.status }}</th>
                              <th>{{ errorDataAdditionalWMS.message }}</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer justify-content-between">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click.prevent="removeModals()"
                    >
                      {{ this.$t("close_txt") }}
                    </button>
                    <button type="submit" class="btn btn-primary">
                      {{ this.$t("UploadTxt") }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </modal>

        <modal
          name="uploadDataAdditionalStorageWms"
          :draggable="false"
          :scrollable="true"
          :height="'auto'"
        >
          <div
            class="modal fade show"
            tabindex="-1"
            style="display: block; margin-top: 2%"
            aria-modal="true"
            role="dialog"
          >
            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content">
                <form
                  class="forms-sample"
                  @submit.prevent="submitDataAdditionalStorageWms"
                  method="POST"
                >
                  <div class="modal-header">
                    <h5 class="modal-title" id="uploadDataAdditionalStorageWms">
                      {{ this.$t("uploadDataAdditionalStorageWms") }}
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      aria-label="btn-close"
                      @click.prevent="removeModals()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div class="mb-3">
                      <label for="files" class="form-label">{{ this.$t("file") }}:</label>
                      <input
                        type="file"
                        class="form-control"
                        ref="fileDataAdditionalStorageWms"
                        @change="handleFileUploadDataAdditionalStorageWms($event)"
                        required
                      />

                      <div v-if="errors.file_data_additional_storage_wms">
                        <div
                          v-for="error in errors.file_data_additional_storage_wms"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                    <div class="mb-3">
                      <br />
                      <label
                        for="downloadTemplateDataAdditionalStorageWms"
                        class="form-label"
                      >
                        <a
                          @click="downloadDataAdditionalStorageWmsTemplate()"
                          style="color: #6571ff; text-decoration: none"
                        >
                          {{ this.$t("downloadTemplateDataAdditionalStorageWms") }}
                        </a>
                      </label>
                    </div>
                    <div class="mb-3" v-if="errorsDataAdditionalStorageWmsUpload">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <th>{{ $t("lineNo") }}</th>
                            <th>{{ $t("statusTxt") }}</th>
                            <th>{{ $t("messageTxt") }}</th>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(
                                errorDataAdditionalStorageWms, index
                              ) in errorsDataAdditionalStorageWmsUpload"
                              :key="index"
                            >
                              <th>{{ errorDataAdditionalStorageWms.No }}</th>
                              <th>
                                {{ errorDataAdditionalStorageWms.status }}
                              </th>
                              <th>
                                {{ errorDataAdditionalStorageWms.message }}
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer justify-content-between">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click.prevent="removeModals()"
                    >
                      {{ this.$t("close_txt") }}
                    </button>
                    <button type="submit" class="btn btn-primary">
                      {{ this.$t("UploadTxt") }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </modal>

        <modal
          name="formSchedulerData"
          :draggable="false"
          :scrollable="true"
          :height="'auto'"
        >
          <div
            class="modal fade show"
            tabindex="-1"
            style="display: block; margin-top: 2%"
            aria-modal="true"
            role="dialog"
          >
            <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content">
                <form
                  class="forms-sample"
                  @submit.prevent="submitSchedulerData()"
                  method="POST"
                >
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      {{ this.$t("downloadDataList") }}
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      aria-label="btn-close"
                      @click.prevent="removeModals()"
                    ></button>
                  </div>

                  <div class="modal-body">
                    <div class="mb-3">
                      <label for="emailAddress" class="form-label"
                        >{{ this.$t("emailAddress") }} :</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="emailAddress"
                        :placeholder="$t('emailAddress')"
                        v-model="SchedulerData.email_to"
                        required
                      />
                    </div>

                    <div class="mb-3">
                      <label for="type" class="form-label">{{ this.$t("type") }} :</label>
                      <br />

                      <div class="form-check form-check-inline">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="checkInline"
                          value="billingCmlTemplateFlux"
                          v-model="SchedulerDataType"
                        />
                        <label class="form-check-label" for="checkInline">
                          Template Billing List Flux
                        </label>
                      </div>

                      <div class="form-check form-check-inline">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="checkInline"
                          value="billingReport"
                          v-model="SchedulerDataType"
                        />
                        <label class="form-check-label" for="checkInline">
                          Proforma Invoice Report
                        </label>
                      </div>

                      <div v-if="errors.type">
                        <div
                          v-for="error in errors.type"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <h6 class="card-title">
                        {{ this.$t("historyDownload") }}
                      </h6>
                      <div class="table-responsive">
                        <table
                          v-if="this.dataSchedulerHistoryStatus"
                          class="table table-bordered"
                        >
                          <thead>
                            <tr>
                              <td>{{ this.$t("statusTxt") }}</td>
                              <td>{{ this.$t("type") }}</td>
                              <td>{{ this.$t("file") }}</td>
                              <td>{{ this.$t("created_by") }}</td>
                              <td>{{ this.$t("updated_by") }}</td>
                              <td>{{ this.$t("created_at") }}</td>
                              <td>{{ this.$t("updated_at") }}</td>
                            </tr>
                          </thead>

                          <tbody
                            v-for="item in this.dataSchedulerHistory"
                            :key="item.id_scheduler"
                          >
                            <tr
                              v-if="
                                item.type == 'billingReport' ||
                                item.type == 'billingCmlTemplateFlux'
                              "
                            >
                              <td>{{ item.status }}</td>
                              <td>
                                <p v-if="item.type == 'billingReport'">
                                  Proforma Invoice Report
                                </p>
                                <p v-if="item.type == 'billingCmlTemplateFlux'">
                                  Template Billing List Flux
                                </p>
                              </td>
                              <td>
                                <p v-if="item.status !== 'DRAFT'">
                                  <a :href="item.url_data" target="_blank">Download</a>
                                </p>
                              </td>
                              <td>{{ item.created_by }}</td>
                              <td>{{ item.updated_by }}</td>
                              <td>{{ item.created_at }}</td>
                              <td>{{ item.updated_at }}</td>
                            </tr>
                            <tr
                              v-else-if="
                                item.type == 'billingApiFlux' && item.url_data !== null
                              "
                            >
                              <td>{{ item.status }}</td>
                              <td>
                                <p v-if="item.type == 'billingApiFlux'">
                                  Interface To Flux Error
                                </p>
                              </td>
                              <td>
                                <p v-if="item.status !== 'DRAFT'">
                                  <a :href="item.url_data" target="_blank">Download</a>
                                </p>
                              </td>
                              <td>{{ item.created_by }}</td>
                              <td>{{ item.updated_by }}</td>
                              <td>{{ item.created_at }}</td>
                              <td>{{ item.updated_at }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <table v-else class="table table-bordered">
                          <tr>
                            <td colspan="3"></td>
                          </tr>
                          <tr>
                            <td colspan="2">{{ $t("loadingTxt") }} ...</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer justify-content-between">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click.prevent="removeModals()"
                    >
                      {{ this.$t("close_txt") }}
                    </button>
                    <button type="submit" class="btn btn-primary">
                      {{ this.$t("submitFormTxt") }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </modal>
        <!--end::modal-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";

export default {
  name: "CmlBillingHeaderDetail",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
  },
  data() {
    return {
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      recalculateDataDates: {
        startDate: null,
        endDate: null,
      },
      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(),
        ],
      },
      langs: ["id", "en"],
      detailUser: [],
      permision_role: [],
      detailDivisi: [],
      totalRecords: 0,
      maxToasts: 100,
      position: "up right",
      header: "",
      roleName: "",
      userData: "",
      companyCode: "",
      companyName: "",
      transactionFromDate: "",
      transactionToDate: "",
      isLoading: false,
      closeBtn: true,

      fileDataAdditionalWMS: "",
      fileOvertime: "",
      fileExtraHandling: "",
      fileDataSAP: "",
      fileBillingListData: "",
      fileDataAdditionalStorageWms: "",

      errorsDataAdditionalStorageWmsUpload: false,
      errorsDataAdditionalWMSUpload: false,
      errorsOvertimeUpload: false,
      errorsExtraHandlingUpload: false,
      errorsDataSAPUpload: false,

      formsDataAdditionalStorageWms: {
        idBillingHeader: "",
        idBillingDetail: "",
        file_data_additional_storage_wms: "",
      },
      formsDataAdditionalWMS: {
        idBillingHeader: "",
        idBillingDetail: "",
        file_data_additional_wms: "",
      },
      formsOvertime: {
        idBillingHeader: "",
        idBillingDetail: "",
        file_overtime: "",
      },
      formsExtraHandling: {
        idBillingHeader: "",
        idBillingDetail: "",
        file_extra_handling: "",
      },
      formsDataSAP: {
        idBillingHeader: "",
        idBillingDetail: "",
        file_data_sap: "",
      },

      dataSchedulerHistoryStatus: false,
      dataSchedulerBillingListDataHistoryStatus: false,

      dataSchedulerHistory: [],
      SchedulerDataType: [],
      idBillingHeader: [],
      bm_rate_header: {},
      bm_tarif_master_header: {},
      rows: [],
      errors: [],
      dropdownStatus: [
        "DRAFT",
        "PROCESSING",
        "COMPLETED",
        "RECALCULATE",
        "CONFIRMED",
        "INTERFACE NOT COMPLETED",
        "INTERFACE COMPLETED",
        "INTERFACE PROCESSING",
        "MATCHING PROCESS",
        "INTERFACE FAILED",
      ],
      excludedRoles: ["om_bulk", "om_cml_basf01", "om_cml_basf02_rm", "om_cml_basf02_fg"],
      SchedulerData: { type: "", email_to: "", idBillingHeader: "", file: "" },
      forms: {
        weeklyTransmitFlag: "",
        interfaceStatus: "",
        akumFlag: "",
        qtyBegBalRentPall: 0,
        qtyBeginningBalance: 0,
        totalRowInterfaces: 0,
        sapDataFlag: "",
        overtimeFlag: "",
        extraHandlingFlag: "",
        idBillingHeader: "",
        tariffId: "",
        customerId: "",
        warehouseId: "",
        transactionToDate: "",
        transactionFromDate: "",
        status: "",
        amount: "",
        idRateHeader: "",
        transactionDate: "",
        addwho: "",
        editwho: "",
        adddate: "",
        editdate: "",
        multiWhFlag: "",
      },
      formsLogsSyncTrxCount: {
        LogsSyncTrxQueuedCount: null,
        LogsSyncTrxFailedCount: null,
        LogsSyncTrxProcessingCount: null,
      },
      // columns: [
      //   {
      //     label: this.$t("action_txt"),
      //     field: "actions",
      //     thClass: "text-center",
      //     width: "110px",
      //     sortable: false,
      //     filterOptions: {
      //       customFilter: false,
      //       enabled: false,
      //     },
      //   },
      //   {
      //     label: this.$t("chargeCategory_txt"),
      //     field: "chargeCategory",
      //     width: "450px",
      //     thClass: "text-center",
      //   },
      //   {
      //     label: this.$t("qtyCharge"),
      //     field: "qtyCharge",
      //     thClass: "text-center",
      //     filterOptions: {
      //       customFilter: false,
      //       enabled: false, // enable filter for this column
      //       placeholder: this.$t("qtyCharge"), // placeholder for filter input
      //       filterValue: "", // initial populated value for this filter
      //       filterDropdownItems: [], // dropdown (with selected values) instead of text input
      //       trigger: "enter", //only trigger on enter not on keyup
      //     },
      //   },
      //   {
      //     label: this.$t("rate"),
      //     field: "rate",
      //     thClass: "text-center",
      //     filterOptions: {
      //       customFilter: false,
      //       enabled: false, // enable filter for this column
      //       placeholder: this.$t("rate"), // placeholder for filter input
      //       filterValue: "", // initial populated value for this filter
      //       filterDropdownItems: [], // dropdown (with selected values) instead of text input
      //       trigger: "enter", //only trigger on enter not on keyup
      //     },
      //   },
      //   {
      //     label: this.$t("amount_txt"),
      //     field: "amountCategory",
      //     thClass: "text-center",
      //     filterOptions: {
      //       customFilter: false,
      //       enabled: false, // enable filter for this column
      //       placeholder: this.$t("amount_txt"), // placeholder for filter input
      //       filterValue: "", // initial populated value for this filter
      //       filterDropdownItems: [], // dropdown (with selected values) instead of text input
      //       trigger: "enter", //only trigger on enter not on keyup
      //     },
      //   },
      //   {
      //     label: this.$t("chargeType_txt"),
      //     field: "chargeType",
      //     width: "500px",
      //     thClass: "text-center",
      //   },
      //   {
      //     label: this.$t("idBillingDetail"),
      //     field: "idBillingDetail",
      //     hidden: true,
      //     thClass: "text-center",
      //     width: "500px",
      //     filterOptions: {
      //       customFilter: false,
      //       enabled: false, // enable filter for this column
      //       placeholder: this.$t("idBillingDetail"), // placeholder for filter input
      //       filterValue: "", // initial populated value for this filter
      //       filterDropdownItems: [], // dropdown (with selected values) instead of text input
      //       trigger: "enter", //only trigger on enter not on keyup
      //     },
      //   },
      //   {
      //     label: this.$t("rateBaseDesc_txt"),
      //     field: "rateBaseDesc",
      //     hidden: true,
      //     thClass: "text-center",
      //     width: "500px",
      //     filterOptions: {
      //       customFilter: false,
      //       enabled: false, // enable filter for this column
      //       placeholder: this.$t("rateBaseDesc_txt"), // placeholder for filter input
      //       filterValue: "", // initial populated value for this filter
      //       filterDropdownItems: [], // dropdown (with selected values) instead of text input
      //       trigger: "enter", //only trigger on enter not on keyup
      //     },
      //   },
      //   {
      //     label: this.$t("SAPMaterialCode"),
      //     field: "SAPMaterialCode",
      //     thClass: "text-center",
      //     hidden: true,
      //     width: "100px",
      //     filterOptions: {
      //       customFilter: false,
      //       enabled: false, // enable filter for this column
      //       placeholder: this.$t("chargeType_filter_txt"), // placeholder for filter input
      //       filterValue: "", // initial populated value for this filter
      //       filterDropdownItems: [], // dropdown (with selected values) instead of text input
      //       trigger: "enter", //only trigger on enter not on keyup
      //     },
      //   },
      // ],
      columns: this.getTableColumns(),
      AccumFlags: [
        {
          id: 1,
          name: "Package Good",
        },
        {
          id: 2,
          name: "Packaging Material",
        },
        {
          id: 3,
          name: "Isotank",
        },
      ],
    };
  },
  watch: {},
  methods: {
    getTableColumns() {
      // Role yang tidak menampilkan kolom amountCategory
      const hiddenRoles = [
        "om_bulk",
        "om_cml_basf01",
        "om_cml_basf02_rm",
        "om_cml_basf02_fg",
      ];

      const roleName = this.permision_role?.role?.name;
      const isHiddenRole = hiddenRoles.includes(roleName);

      // Define columns with a fixed order
      let columns = [
        {
          label: this.$t("action_txt"),
          field: "actions",
          thClass: "text-center",
          width: "110px",
          sortable: false,
          filterOptions: {
            customFilter: false,
            enabled: false,
          },
        },
        {
          label: this.$t("chargeCategory_txt"),
          field: "chargeCategory",
          width: "450px",
          thClass: "text-center",
        },
        {
          label: this.$t("qtyCharge"),
          field: "qtyCharge",
          thClass: "text-center",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("qtyCharge"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        !isHiddenRole
          ? {
              label: this.$t("rate"),
              field: "rate",
              thClass: "text-center",
              filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("rate"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
              },
            }
          : null,
        !isHiddenRole
          ? {
              label: this.$t("amount_txt"),
              field: "amountCategory",
              thClass: "text-center",
              filterOptions: {
                customFilter: false,
                enabled: false, // enable filter for this column
                placeholder: this.$t("amount_txt"), // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                trigger: "enter", //only trigger on enter not on keyup
              },
            }
          : null,
        {
          label: this.$t("chargeType_txt"),
          field: "chargeType",
          width: "500px",
          thClass: "text-center",
        },
        {
          label: this.$t("idBillingDetail"),
          field: "idBillingDetail",
          hidden: true,
          thClass: "text-center",
          width: "500px",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("idBillingDetail"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("rateBaseDesc_txt"),
          field: "rateBaseDesc",
          hidden: true,
          thClass: "text-center",
          width: "500px",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("rateBaseDesc_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("SAPMaterialCode"),
          field: "SAPMaterialCode",
          thClass: "text-center",
          hidden: true,
          width: "100px",
          filterOptions: {
            customFilter: false,
            enabled: false, // enable filter for this column
            placeholder: this.$t("chargeType_filter_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ];

      // Filter kolom null (saat hidden) dari array
      return columns.filter((column) => column !== null);
    },

    getBadgeClass(status) {
      const statusClasses = {
        DRAFT: "col-md-12 badge bg-light text-secondary btn btn-outline-secondary",
        COMPLETED: "col-md-12 badge bg-light text-success btn btn-outline-success",
        CONFIRMED: "col-md-12 badge bg-light text-warning btn btn-outline-warning",
        "INTERFACE PROCESSING":
          "col-md-12 badge bg-light text-warning btn btn-outline-warning",
        "INTERFACE COMPLETED": "col-md-12 badge bg-light text-info btn btn-outline-info",
        "INTERFACE NOT COMPLETED":
          "col-md-12 badge bg-light text-danger btn btn-outline-danger",
        "SYNC FAILED": "col-md-12 badge bg-light text-danger btn btn-outline-danger",
        "INTERFACE FAILED": "col-md-12 badge bg-light text-danger btn btn-outline-danger",
      };
      return (
        statusClasses[status] ||
        "col-md-12 badge bg-light text-warning btn btn-outline-warning"
      );
    },

    getDataSummaryLogsSyncTrxCount() {
      if (this.forms.weeklyTransmitFlag !== "Y") {
        this.isLoading = true;
        var params = this.$onBehind(this.$route.params.id);

        const baseURI =
          this.$settings.endPointBilling +
          "dashboard/cml-billing/billing/get-data-summary-logs-sync-trx-count/" +
          params[0];
        return this.$http
          .get(baseURI, { timeout: 60000 })
          .then((response) => {
            this.isLoading = false;
            this.formsLogsSyncTrxCount = response.data.datas;
          })
          .catch((error) => {
            this.isLoading = false;

            if (error.code == "ECONNABORTED") {
              this.error(this.$t("check_internet_connection_txt"));
            } else {
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  //this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                  this.logout();
                } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            }
          });
      }
    },

    // function pack upload extra handling
    submitExtraHandling() {
      this.isLoading = true;

      let formData = new FormData();
      formData.append("file", this.fileExtraHandling);
      formData.append("idBillingHeader", this.formsExtraHandling.idBillingHeader);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-extrahandling-new-upload";

      this.$http
        .post(baseURI, formData)
        .then((response) => {
          this.isLoading = false;
          this.errorsExtraHandlingUpload = response.data.datas;
          this.resetForm();
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errorsExtraHandlingUpload = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    handleFileUploadExtraHandling(event) {
      this.fileExtraHandling = event.target.files[0];
    },
    downloadExtraHandlingTemplate() {
      var params = this.$onBehind(this.$route.params.id);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-download-template-extrahandling-new/" +
        params[0] +
        "?download=download";
      var file_name = "billing-module-cml-template-extrahandling-new.xlsx";

      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
    uploadExtraHandling() {
      var params = this.$onBehind(this.$route.params.id);
      this.formsExtraHandling.idBillingHeader = params[0];
      this.$modal.show("uploadExtraHandling");
    },

    // function pack upload overtime
    submitOvertime() {
      this.isLoading = true;

      let formData = new FormData();
      formData.append("file", this.fileOvertime);
      formData.append("idBillingHeader", this.formsOvertime.idBillingHeader);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-overtime-new-upload";

      this.$http
        .post(baseURI, formData)
        .then((response) => {
          this.isLoading = false;
          this.errorsOvertimeUpload = response.data.datas;
          this.resetForm();
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errorsOvertimeUpload = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    handleFileUploadOvertime(event) {
      this.fileOvertime = event.target.files[0];
    },
    downloadOvertimeTemplate() {
      var params = this.$onBehind(this.$route.params.id);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-download-template-overtime-new/" +
        params[0] +
        "?download=download";
      var file_name = "billing-module-cml-template-overtime-new.xlsx";

      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
    uploadOvertime() {
      var params = this.$onBehind(this.$route.params.id);
      this.formsOvertime.idBillingHeader = params[0];
      this.$modal.show("uploadOvertime");
    },

    // function pack upload data sap
    submitDataSAP() {
      this.isLoading = true;

      let formData = new FormData();
      formData.append("file", this.fileDataSAP);
      formData.append("idBillingHeader", this.formsDataSAP.idBillingHeader);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-data-cust-sap-upload";
      this.$http
        .post(baseURI, formData)
        .then((response) => {
          this.isLoading = false;
          this.errorsDataSAPUpload = response.data.datas;
          this.resetForm();
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errorsDataSAPUpload = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    handleFileUploadDataSAP(event) {
      this.fileDataSAP = event.target.files[0];
    },
    uploadDataSAP() {
      var params = this.$onBehind(this.$route.params.id);
      this.formsDataSAP.idBillingHeader = params[0];
      this.$modal.show("uploadDataSAP");
    },
    downloadDataSAPTemplate() {
      var params = this.$onBehind(this.$route.params.id);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-download-template-basf-sap/" +
        params[0] +
        "?download=download";
      var file_name = "billing-module-cml-template-basf-sap.xlsx";

      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    // function pack upload data additional wms
    handleFileUploadDataAdditionalWMS(event) {
      this.fileDataAdditionalWMS = event.target.files[0];
    },
    uploadDataAdditionalWMS() {
      var params = this.$onBehind(this.$route.params.id);
      this.formsDataAdditionalWMS.idBillingHeader = params[0];
      this.$modal.show("uploadDataAdditionalWMS");
    },
    downloadDataAdditionalWMSTemplate() {
      var params = this.$onBehind(this.$route.params.id);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-download-template-additional-data-wms/" +
        params[0] +
        "?download=download";
      var file_name = "billing-module-cml-template-additional-wms.xlsx";

      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
    submitDataAdditionalWMS() {
      this.isLoading = true;

      let formData = new FormData();
      formData.append("file", this.fileDataAdditionalWMS);
      formData.append("idBillingHeader", this.formsDataAdditionalWMS.idBillingHeader);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-data-additional-wms-upload";
      this.$http
        .post(baseURI, formData)
        .then((response) => {
          this.isLoading = false;
          this.errorsDataAdditionalWMSUpload = response.data.datas;
          this.resetForm();
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errorsDataAdditionalWMSUpload = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    // function pack upload data additional storage wms
    handleFileUploadDataAdditionalStorageWms(event) {
      this.fileDataAdditionalStorageWms = event.target.files[0];
    },
    uploadDataAdditionalStorageWms() {
      var params = this.$onBehind(this.$route.params.id);
      this.formsDataAdditionalStorageWms.idBillingHeader = params[0];
      this.$modal.show("uploadDataAdditionalStorageWms");
    },
    downloadDataAdditionalStorageWmsTemplate() {
      var params = this.$onBehind(this.$route.params.id);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-download-template-additional-storage-data-wms/" +
        params[0] +
        "?download=download";
      var file_name = "billing-module-cml-template-additional-storage-wms.xlsx";

      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
    submitDataAdditionalStorageWms() {
      this.isLoading = true;
      let formData = new FormData();
      formData.append("file", this.fileDataAdditionalStorageWms);
      formData.append(
        "idBillingHeader",
        this.formsDataAdditionalStorageWms.idBillingHeader
      );

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-data-additional-storage-wms-upload";
      this.$http
        .post(baseURI, formData)
        .then((response) => {
          this.isLoading = false;
          this.errorsDataAdditionalStorageWmsUpload = response.data.datas;
          this.resetForm();
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errorsDataAdditionalStorageWmsUpload = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    resetForm() {
      this.fileOvertime = "";
      this.fileExtraHandling = "";
      this.fileDataSAP = "";
      this.fileDataAdditionalWMS = "";
      this.fileDataAdditionalStorageWms = "";
      this.clearrecalculateDates();
    },

    confirmedData() {
      var params = this.$onBehind(this.$route.params.id);
      var id = params[0];

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          let formData = {
            status:
              this.forms.weeklyTransmitFlag === "Y" ? "INTERFACE COMPLETED" : "CONFIRMED",
          };

          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/update-header-status/" +
            id;
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadData(id);
                this.loadDataDetails(id);
                this.generateXML(id);
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    weeklyTransmit() {
      var params = this.$onBehind(this.$route.params.id);
      var id = params[0];

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: "WEEKLY TRANSMITTING",
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/update-header-status/" +
            id;
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadData(id);
                this.loadDataDetails(id);
                this.addQueueWeeklyTransmit(id);
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    dataMatchingProcess() {
      var params = this.$onBehind(this.$route.params.id);
      var id = params[0];

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: "MATCHING PROCESS",
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/update-header-status/" +
            id;
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadData(id);
                this.loadDataDetails(id);
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    generateXML(id) {
      this.isLoading = true;
      let formData = new FormData();
      formData.append("type", "billingApiFlux");
      formData.append("email_to", "blank@blank.com");
      formData.append("idBillingHeader", id);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-insert-scheduler-data";
      this.$http.post(baseURI, formData).then(() => {});
    },

    addQueueWeeklyTransmit(id) {
      this.isLoading = true;
      let formData = new FormData();
      formData.append("type", "weeklyTransmitToFlux");
      formData.append("email_to", "blank@blank.com");
      formData.append("idBillingHeader", id);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-insert-scheduler-data";
      this.$http.post(baseURI, formData).then(() => {});
    },

    detailDataDetail(index, row) {
      var chargeCategory = row.chargeCategory;
      var typeRate = row.typeRate;
      var subDetailRateFlag = row.subDetailRateFlag;
      var params = this.$onRandom(row.idBillingDetail);

      if (typeRate === "handling" && chargeCategory === "RENTAL PALLET") {
        window.location.href =
          "/billing-cml/billing/detail-handling-rental-pallet/" +
          params +
          "/" +
          row.idBillingHeader;
      } else if (
        (typeRate === "storage" && chargeCategory === "STORAGE") ||
        chargeCategory === "RENTAL PALLET"
      ) {
        window.location.href =
          "/billing-cml/billing/detail-storage/" + params + "/" + row.idBillingHeader;
      } else if (
        subDetailRateFlag == "N" && chargeCategory === "HANDLING IN" ||
        chargeCategory === "SPECIAL CHARGE"
      ) {
        window.location.href =
          "/billing-cml/billing/detail-handling-in/" + params + "/" + row.idBillingHeader + "/" + null;
      } else if (subDetailRateFlag == "N" && chargeCategory === "HANDLING OUT") {
        window.location.href =
          "/billing-cml/billing/detail-handling-out/" +
          params +
          "/" +
          row.idBillingHeader + "/" + null;
      } else if (subDetailRateFlag == "Y" && chargeCategory === "HANDLING IN" || chargeCategory === "HANDLING OUT") {
        window.location.href =
          "/billing-cml/billing/detail-handling/" + params + "/" + row.idBillingHeader;
      } else if (chargeCategory === "OVERTIME") {
        window.location.href =
          "/billing-cml/billing/detail-handling-overtime/" +
          params +
          "/" +
          row.idBillingHeader;
      } else if (chargeCategory === "EXTRA HANDLING") {
        window.location.href =
          "/billing-cml/billing/detail-handling-extra/" +
          params +
          "/" +
          row.idBillingHeader;
      } else if (chargeCategory === "VALUE ADDED SERVICE CHARGE") {
        window.location.href =
          "/billing-cml/billing/detail-handling-vas/" +
          params +
          "/" +
          row.idBillingHeader;
      } else if (chargeCategory === "MINIMUM CHARGE") {
        window.location.href =
          "/billing-cml/billing/detail-handling-minimum-charge/" +
          params +
          "/" +
          row.idBillingHeader;
      } else if (chargeCategory === "EQUIPMENT TYPE") {
        window.location.href =
          "/billing-cml/billing/detail-equipment-type/" +
          params +
          "/" +
          row.idBillingHeader;
      } else {
        //console.log(index);
      }
    },

    detailDataDetailAdditional(index, row) {
      var chargeCategory = row.chargeCategory;
      // var chargeTypeCode = row.chargeTypeCode
      var params = this.$onRandom(row.idBillingDetail);

      if (chargeCategory === "HANDLING IN" || chargeCategory === "SPECIAL CHARGE") {
        window.location.href =
          "/billing-cml/billing/detail-handling-in-additional/" +
          params +
          "/" +
          row.idBillingHeader;
      } else if (chargeCategory === "HANDLING OUT") {
        window.location.href =
          "/billing-cml/billing/detail-handling-out-additional/" +
          params +
          "/" +
          row.idBillingHeader;
      } else if (chargeCategory === "EQUIPMENT TYPE") {
        window.location.href =
          "/billing-cml/billing/detail-equipment-type-additional/" +
          params +
          "/" +
          row.idBillingHeader;
      } else {
        //console.log(index);
      }
    },

    detailSumHandling(index, row) {
      var params = this.$onRandom(row.idBillingDetail);
      window.location.href =
        "/billing-cml/billing/detail-summary-handling-charge/" +
        params +
        "/" +
        row.idBillingHeader;
    },

    detailSumStrgMultiWh(index, row) {
      var params = this.$onRandom(row.idBillingDetail);
      window.location.href =
        "/billing-cml/billing/detail-summary-storage-multiwh/" +
        params +
        "/" +
        row.idBillingHeader;
    },

    detailSumStrgMuid(index, row) {
      var params = this.$onRandom(row.idBillingDetail);
      window.location.href =
        "/billing-cml/billing/detail-summary-storage-muid/" +
        params +
        "/" +
        row.idBillingHeader;
    },

    detailSumStrgQty(index, row) {
      var params = this.$onRandom(row.idBillingDetail);
      window.location.href =
        "/billing-cml/billing/det-sum-strg-qty/" + params + "/" + row.idBillingHeader;
    },

    detailSumStrgPltUsed(index, row) {
      var params = this.$onRandom(row.idBillingDetail);
      window.location.href =
        "/billing-cml/billing/detail-summary-storage-pltused/" +
        params +
        "/" +
        row.idBillingHeader;
    },

    recalculateDates() {
      if (this.recalculateDataDates.startDate && this.recalculateDataDates.endDate) {
        this.transactionFromDate = this.$moment(
          String(this.recalculateDataDates.startDate)
        ).format("YYYY-MM-DD");
        this.transactionToDate = this.$moment(
          String(this.recalculateDataDates.endDate)
        ).format("YYYY-MM-DD");
      }
    },

    clearrecalculateDates() {
      this.recalculateDates = {
        startDate: null,
        endDate: null,
      };

      this.transactionFromDate = "";
      this.transactionToDate = "";
    },

    recalculateData() {
      var params = this.$onBehind(this.$route.params.id);
      var id = params[0];

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: "RECALCULATE",
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/update-header-status/" +
            id;
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadData(id);
                this.loadDataDetails(id);
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    destroyMassSubDetailOnlyByDate() {
      this.isLoading = true;
      var params = this.$onBehind(this.$route.params.id);

      let formData = new FormData();
      formData.append("idBillingHeader", params[0]);
      formData.append("startDate", this.transactionFromDate);
      formData.append("endDate", this.transactionToDate);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/delete-mass-sub-detail-recalculate-bydate";

      this.$http
        .post(baseURI, formData)
        .then((response) => {
          this.isLoading = false;
          this.success(response.data.datas.messages);
          this.loadData(params[0]);
          this.loadDataDetails(params[0]);
          this.resetForm();
        })
        .catch((error) => {
          this.loading();
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    editData() {
      var params = this.$route.params.id;
      window.location.href = "/billing-cml/billing/header/edit/" + params;
    },

    editForm() {
      var params = this.$route.params.id;
      window.location.href = "/billing-cml/billing/header/edit/" + params;
    },

    downloadForm() {
      this.dataSchedulerHistoryStatus = false;
      var params = this.$onBehind(this.$route.params.id);
      this.SchedulerData.idBillingHeader = params[0];
      this.SchedulerData.email_to = this.userData.email;
      this.SchedulerDataType = [];

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-index-scheduler-data?type=billingApiFlux,billingReport,billingCmlTemplateFlux&idBillingHeader=" +
        params[0];
      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then((response) => {
          this.dataSchedulerHistory = response.data.datas;
          this.dataSchedulerHistoryStatus = true;
          this.$modal.show("formSchedulerData");
        })
        .catch((error) => {
          this.dataSchedulerHistoryStatus = true;

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    backForm() {
      // const userDatas = this.$getUserInfo();
      // let roleName = userDatas.sub.role.name;
      // if (roleName == "om_cml_basf01") {
      //   this.header = "BASF01";
      // } else {
      //   if (roleName == "om_cml_basf02_rm") {
      //     this.header = "BASF02RM";
      //   } else {
      //     if (roleName == "om_cml_basf02_fg") {
      //       this.header = "BASF02FG";
      //     } else {
      //       this.header = "";
      //     }
      //   }
      // }

      //window.location.href = "/billing-cml/billing/header/" + this.header;
      window.location.href = "/billing-cml/billing/header/";
    },

    deleteForm() {
      var params = this.$onBehind(this.$route.params.id);
      var idBillingHeader = params[0];

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = { status: "status" };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/delete/" +
            idBillingHeader;
          this.$http
            .delete(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.backForm();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    loadData(id) {
      this.isLoading = true;

      const baseURI =
        this.$settings.endPointBilling + "dashboard/cml-billing/billing/detail/" + id;
      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then((response) => {
          this.isLoading = false;
          this.forms = response.data.datas;
          this.forms.amount = this.toCurrency(response.data.datas.amount);
          this.bm_rate_header = response.data.datas.bm_rate_header;
          this.bm_tarif_master_header = response.data.datas.bm_tarif_master_header;
          this.forms.transactionDate =
            response.data.datas.transactionFromDate +
            "~" +
            response.data.datas.transactionToDate;
          this.getDataSummaryLogsSyncTrxCount();
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    getRateDetail() {
      this.openRateDetail();
    },

    getDataSAP() {
      this.openDataSAP();
    },

    getDataAkumActivity() {
      this.openDataAkumActivity();
    },

    getDataLogsSyncTrx() {
      this.openDataLogsSyncTrx();
    },

    removeModals() {
      this.$modal.hide("formSchedulerData");
      this.$modal.hide("detailRateCmlbilling");

      this.$modal.hide("uploadOvertime");
      this.$modal.hide("uploadExtraHandling");
      this.$modal.hide("uploadDataSAP");
      this.$modal.hide("uploadDataAdditionalWMS");
      this.$modal.hide("uploadDataAdditionalStorageWms");

      this.errorsExtraHandlingUpload = false;
      this.errorsOvertimeUpload = false;
      this.errorsDataSAPUpload = false;
      this.errorsDataAdditionalWMSUpload = false;
      this.errorsDataAdditionalStorageWmsUpload = false;

      this.fileOvertime = "";
      this.fileExtraHandling = "";
      this.fileDataSAP = "";
      this.fileDataAdditionalWMS = "";
      this.fileDataAdditionalStorageWms = "";

      this.SchedulerData.type = "";
      this.SchedulerData.email_to = "";
      this.SchedulerData.idBillingHeader = "";

      var params = this.$onBehind(this.$route.params.id);
      this.loadData(params[0]);
      this.loadDataDetails(params[0]);
    },

    openRateDetail() {
      var params = this.$onRandom(this.forms.idRateHeader);
      var href = "/billing-cml/rates/header/detail/" + params;
      window.open(href, "_blank");
    },

    openDataSAP() {
      var params = this.$onRandom(this.forms.idBillingHeader);
      var href = "/billing-cml/billing/detail-data-sap/" + params;
      window.open(href, "_blank");
    },

    openDataAkumActivity() {
      var params = this.$onRandom(this.forms.idBillingHeader);
      var href = "/billing-cml/billing/detail-data-akum-activity/" + params;
      window.open(href, "_blank");
    },

    openDataLogsSyncTrx() {
      var params = this.$onRandom(this.forms.idBillingHeader);
      var href = "/billing-cml/billing/detail-logs-sync-trx/" + params;
      window.open(href, "_blank");
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.userData = userDatas.sub;
      this.roleName = userDatas.sub.role.name;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "BillingCmlController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IDR",
      });
      return formatter.format(value);
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    loadDataDetails(id) {
      this.isLoading = true;

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail/" +
        id +
        "?limit=-1";
      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then((response) => {
          this.rows = response.data.datas.data;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },

    submitSchedulerData() {
      if (this.SchedulerDataType.length <= 0) {
        this.errors = { type: [this.$t("please_choose_one")] };
        this.error(this.$t("please_choose_one"));
      } else {
        this.isLoading = true;
        let formData = new FormData();
        formData.append("type", this.SchedulerDataType.toString());
        formData.append("email_to", this.SchedulerData.email_to);
        formData.append("idBillingHeader", this.SchedulerData.idBillingHeader);

        const baseURI =
          this.$settings.endPointBilling +
          "dashboard/cml-billing/billing/bt-billing-detail-insert-scheduler-data";
        this.$http
          .post(baseURI, formData)
          .then((response) => {
            this.isLoading = false;
            this.removeModals();
            this.success(response.data.datas.messages);
            this.resetForm();
          })
          .catch((error) => {
            this.loading();

            if (error.code == "ECONNABORTED") {
              this.error(this.$t("check_internet_connection_txt"));
            } else {
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                  this.logout();
                } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            }
          });
      }
    },

    downloadDataBillingDetail() {
      var params = this.$onBehind(this.$route.params.id);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail/" +
        params[0] +
        "?download=download";
      this.isLoading = true;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          this.isLoading = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    downloadDataBillingDetailHideRate() {
      var params = this.$onBehind(this.$route.params.id);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/download-data-billing-detail-hide-rate/" +
        params[0] +
        "?download=download";
      this.isLoading = true;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          this.isLoading = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
  },
  events: {},
  mounted() {
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.loadDataDetails(params[0]);
    this.fetchIt();
    this.columns = this.getTableColumns();

    this.$root.$on("bv::tooltip::show", () => {
      //console.log("bvEvent:", bvEvent);
    });
  },
};
</script>

<style type="text/css"></style>
